import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';
import { b as bem } from './p-g1JgJ7wn.js';
import { r as resolveAppearance } from './p-CkrRd9Ud.js';
import { u as unscopeTagName } from './p-BrBYYH1P.js';
import { d as defineCustomElement$2 } from './p-BMLmP8GU.js';

const cosmosActionMenuGroupCss = ".cosmos-action-menu-group{display:flex;flex-direction:column;gap:2px;padding-bottom:var(--cosmos-action-menu-group-padding-bottom, 8px)}.cosmos-action-menu-group__label{--cosmos-text-color:var(--cosmos-action-menu-group-color);--cosmos-text-font-family:var(--cosmos-action-menu-group-font-family);--cosmos-text-font-size:var(--cosmos-action-menu-group-font-size);--cosmos-text-font-style:var(--cosmos-action-menu-group-font-style);--cosmos-text-font-weight:var(--cosmos-action-menu-group-font-weight);--cosmos-text-letter-spacing:var(--cosmos-action-menu-group-letter-spacing);--cosmos-text-line-height:var(--cosmos-action-menu-group-line-height);--cosmos-text-text-transform:var(--cosmos-action-menu-group-text-transform);align-items:center;display:flex;height:36px;padding:0 8px 0 8px}";

const CosmosActionMenuGroup$1 = /*@__PURE__*/ proxyCustomElement(class CosmosActionMenuGroup extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.generateClassNames = bem('cosmos-action-menu-group');
    }
    handleAppearanceChange(appearance) {
        if (!appearance) {
            return;
        }
        this.computedAppearance = appearance;
    }
    getUnscopedComponentName() {
        // Make sure we have an unscoped tag name available as a data attribute so we can
        // use it to target slotted elements in a scoped environment
        return unscopeTagName(this.element.tagName.toLowerCase());
    }
    componentDidLoad() {
        resolveAppearance({
            instance: this,
            modeToAppearanceMap: { dark: 'light', light: 'dark' },
            callback: this.handleAppearanceChange.bind(this),
        });
    }
    render() {
        return (h(Host, { key: '75f6ccae80f7b10a866d64e11c0696c0b8efad2d', role: "group", "aria-label": this.label, "data-component-name": this.getUnscopedComponentName() }, h("div", { key: '0972cfcacf5bddecb07c145f22dee851d88975bc', class: this.generateClassNames({ appearance: this.computedAppearance }), part: "base" }, this.label && (h("div", { key: 'f17859182f72acde5da59511191aec0f59f9b478', class: this.generateClassNames('label') }, h("cosmos-text", { key: '9d17c04c1ff0fa5a89c91943b752ae36d1d3597b', exportparts: "base: label", size: "x-small", weight: "medium", clamp: 1, appearance: this.computedAppearance, kind: "subtle" }, this.label))), h("slot", { key: '326ff30ade4176b637fbadf272071398f26fdcfd' }))));
    }
    get element() { return this; }
    static get watchers() { return {
        "appearance": ["handleAppearanceChange"]
    }; }
    static get style() { return cosmosActionMenuGroupCss; }
}, [1, "cosmos-action-menu-group", {
        "appearance": [513],
        "label": [513],
        "computedAppearance": [32]
    }, undefined, {
        "appearance": ["handleAppearanceChange"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-action-menu-group", "cosmos-text"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-action-menu-group":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosActionMenuGroup$1);
            }
            break;
        case "cosmos-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const CosmosActionMenuGroup = CosmosActionMenuGroup$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosActionMenuGroup, defineCustomElement };
